import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {UrlGeneratorEntityImageService} from "../../url-generator-entity-image.service";
import {EntityFile} from "../../entity-file";

@Component({
    selector: 'img-for-entity',
    templateUrl: 'file-jet-img.component.html',
    styleUrls: ['file-jet-img.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ImgForEntityComponent {
  @Input() image: EntityFile;
  @Input() width: number;
  @Input() height: number;
  @Input() alt: string;

  constructor(private urlGenerator: UrlGeneratorEntityImageService) {}

  get src(): string {
    return this.toUrl(1);
  }

  get srcset(): string {
    return `${this.toUrl(2)} 2x, ${this.toUrl(3)} 3x, ${this.toUrl(4)} 4x`;
  }

  private toUrl = (pixelRatio: number) => {
    return this.urlGenerator.generateUrl(this.image);
  };
}
